<script setup lang="ts">
import BrowseHeader from '@/components/browse/header/BrowseHeader.vue';

definePageMeta({
  layout: 'account',
  auth: false,
});

useHead({
  title: 'Terms and Conditions',
});

const { data } = await useFetchData('/pages/terms_of_service', { method: 'get' });
</script>

<template>
  <v-container fluid class="account-container">
    <BrowseHeader class="account-header" />

    <div class="account-content">
      <div v-html="data" class="html-data"></div>
    </div>
  </v-container>
</template>
